module.exports = __webpack_public_path__ + "static/img/33-Build-to-Rent-BTR-GettyImages-927856276.08bf33ec.jpg";